import React from 'react';
import classNames from 'classnames/bind';
import style from './LoginNoticeModal.module.scss';
import Modal from '../../components/common/modal/Modal';
import ButtonCommon from '../../components/common/button/ButtonCommon';
import dayjs from '../../util/dayjs';
import { useLoginNoticeStore } from './loginNoticeStore';

const cx = classNames.bind(style);

// 로그인 직후 직전 접속 정보를 보여 줘 본인이 아닌 접속을 알아챌 수 있게 한다(ISMS)
const LoginNoticeModal = () => {
  const notice = useLoginNoticeStore((state) => state.notice);
  const close = useLoginNoticeStore((state) => state.close);

  if (!notice) return null;

  return (
    <Modal onClose={close} isCloseOnClickBackdrop>
      <div className={cx('container')}>
        <h3 className={cx('title')}>직전 접속 정보</h3>
        {notice.previousLoginDateTime ? (
          <dl className={cx('list')}>
            <dt>일시</dt>
            <dd>{dayjs(notice.previousLoginDateTime).format('YYYY.MM.DD HH:mm:ss')}</dd>
            <dt>IP</dt>
            <dd>{notice.previousLoginIp ?? '기록 없음'}</dd>
          </dl>
        ) : (
          <p className={cx('description')}>이전 로그인 기록이 없습니다.</p>
        )}
        {notice.failCountBeforeLogin > 0 && (
          <div className={cx('warning')}>
            <p>
              직전 로그인 이후 비밀번호가 {notice.failCountBeforeLogin}회 틀렸습니다. 본인이 아니라면 비밀번호를 바꾸고
              마스터 관리자에게 알려 주세요.
            </p>
            {notice.loginFailures.length > 0 && (
              <table className={cx('failures')}>
                <thead>
                  <tr>
                    <th>실패 일시</th>
                    <th>IP</th>
                  </tr>
                </thead>
                <tbody>
                  {notice.loginFailures.map((failure) => (
                    <tr key={failure.dateTime + failure.ip}>
                      <td>{dayjs(failure.dateTime).format('YYYY.MM.DD HH:mm:ss')}</td>
                      <td>{failure.ip}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        )}
        <div className={cx('buttons')}>
          <ButtonCommon onClick={close}>확인</ButtonCommon>
        </div>
      </div>
    </Modal>
  );
};

export default LoginNoticeModal;
